import React from "react";
import { useEffect } from "react";

const SideMenuWrap = (props) => {

  useEffect(() => {
    document.body.style.overflow = "hidden"

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [])
  return (
    <div className="side-menu-wrap">
      <div className="side-menu">{props.children}</div>
    </div>
  );
};

export default SideMenuWrap;
